import React from 'react';
import { styled } from '@mui/material/styles';
import { jsx as _jsx } from "react/jsx-runtime";
/** Shows the content with the Footer */
export function View(props) {
  var children = props.children,
    _props$dataTestid = props['data-testid'],
    testidContent = _props$dataTestid === void 0 ? 'required' : _props$dataTestid;
  return /*#__PURE__*/_jsx(Content, {
    "data-testid": "".concat(testidContent, "-Content"),
    children: children
  });
}
var Content = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    minHeight: 'calc(100vh)',
    padding: theme.spacing(3)
  };
});